/*
 * @Author: wangzhisong
 * @Date: 2022-08-15 15:39:40
 * @LastEditTime: 2022-08-18 09:44:06
 * @FilePath: \smart-community\src\router\modules\monitorManagement.js
 */
export default [
  {
    path: "monitorManagement",
    name: "monitorManagement",
    component: () => import("@/views/monitorManagement/monitorManagement.vue"),
    meta: {
      title: "布控管理"
    }
  },
  {
    path: "keyControl",
    name: "keyControl",
    component: () => import("@/views/monitorManagement/keyControl/index.vue"),
    meta: {
      title: "重点管控"
    }
  }
];
